export const ADD_TO_WISHLIST = "ADD_TO_WISHLIST";
export const SAVE_WISHLIST = "SAVE_WISHLIST";
export const REMOVE_FROM_WISHLIST = "REMOVE_FROM_WISHLIST";
export const REMOVE_ALL_FROM_WISHLIST = "REMOVE_ALL_FROM_WISHLIST";
 
// save wishlist
export const saveWishlist = (item, addToast) => {
  return dispatch => {
    if (addToast) {
      addToast("Lista dei preferiti salvata", {
        appearance: "success",
        autoDismiss: true
      });
    }
    dispatch({ type: SAVE_WISHLIST, payload: item });
  };
};

// add to wishlist
export const addToWishlist = (item, addToast) => {
  return dispatch => {
    if (addToast) {
      addToast("Aggiunto ai preferiti", {
        appearance: "success",
        autoDismiss: true
      });
    }
    dispatch({ type: ADD_TO_WISHLIST, payload: item });
  };
};

// add to wishlist
export const removeFromWishlist = (item, addToast) => {
  return dispatch => {
    if (addToast) {
      addToast("Rimosso dai preferiti", {
        appearance: "success",
        autoDismiss: true
      });
    }
    dispatch({ type: REMOVE_FROM_WISHLIST, payload: item });
  };
};

//remove all from wishlist
export const removeAllFromWishlist = addToast => {
  return dispatch => {
    if (addToast) {
      addToast("Lista dei preferiti eliminata", {
        appearance: "error",
        autoDismiss: true
      });
    }
    dispatch({ type: REMOVE_ALL_FROM_WISHLIST });
  };
};
